/**
 * @file Grid container component for dynamically inject components
 * @author Tom Verschoore de la Houssaije
 */
import * as tslib_1 from "tslib";
import { ComponentFactoryResolver, ViewContainerRef, EventEmitter } from '@angular/core';
import { ComponentRegistry } from '../../core/component-registry';
import { AbstractBase } from '../../core/helpers/abstract-base';
/**
 * This class is used to insert list types, of a specific type, into a template by configuration.
 */
var GridContainerComponent = /** @class */ (function (_super) {
    tslib_1.__extends(GridContainerComponent, _super);
    /**
     * Constructs a list typeContainerComponent
     */
    function GridContainerComponent(containerRef, factoryResolver) {
        var _this = _super.call(this) || this;
        _this.containerRef = containerRef;
        _this.factoryResolver = factoryResolver;
        /** Event triggered when a entity from the list is selected. */
        _this.selectionChanged = new EventEmitter();
        /** Event triggered when a new entity is created. */
        _this.entityCreated = new EventEmitter();
        /** The grid component contained. */
        _this.instance = null;
        _this._component = undefined;
        return _this;
    }
    Object.defineProperty(GridContainerComponent.prototype, "component", {
        /** Gets the component configuration used in this container. */
        get: function () {
            return this._component;
        },
        /**
         * Sets the component configuration used within this container.
         * @param value The component configuration.
         */
        set: function (value) {
            var _this = this;
            this._component = value;
            if (this._component === undefined) {
                return;
            }
            if (this._component.component === undefined) {
                this._component.component = 'PlanboardGridComponent';
            }
            var editor = ComponentRegistry.getComponent('grid', this._component.component);
            if (this.containerRef.length > 0) {
                this.containerRef.clear();
            }
            var componentFactory = this.factoryResolver.resolveComponentFactory(editor);
            var ref = this.containerRef.createComponent(componentFactory, 0);
            this.instance = ref.instance;
            this.instance.configuration = this._component.configuration;
            this.subscriptionPool.add(this.instance.selectionChanged.subscribe(function (item) {
                _this.selectionChanged.emit(item);
            }));
        },
        enumerable: true,
        configurable: true
    });
    return GridContainerComponent;
}(AbstractBase));
export { GridContainerComponent };
